import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import styles from "./StateIcon.module.scss";

interface StateIconProps {
  state: "success" | "error";
}

const StateIcon: React.FC<StateIconProps> = ({ state }) => {
  const icons = {
    error: <FontAwesomeIcon icon={faTriangleExclamation} size="2x" />,
    success: <FontAwesomeIcon icon={faCircleCheck} size="2x" />,
  };

  return <div className={styles[state]}>{icons[state]}</div>;
};

export default StateIcon;
